import React from "react";
import Section from "../Section";
import { Projects } from "../../Data/Data";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { innerRenderPaths } from "../../assest/imgPaths";

const SectionProjectDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Section bg="bg-inherit ">
      <div className="col-span-full md:col-span-10 md:col-start-2 text-primary-bg-blue py-16 md:py-32 px-4 lg:px-0">
        <div className="grid lg:gap-x-[21px] gap-y-0 auto-cols-fr grid-cols-12 grid-rows-auto mx-auto max-w-[1810px] w-full">
          <div className=" col-span-full lg:block lg:col-start-2 lg:col-span-5 h-96 md:h-[850px] xl:h-full self-center relative mb-8 xl:mb-0">
            <img
              // src={image5}
              src={innerRenderPaths[12]}
              loading="lazy"
              data-nuxt-img=""
              id="w-node-_7df739b9-b0f3-491f-7539-52dca451dd1e-0a6b3cff"
              className="opacity-80 rounded-3xl absolute top-0 left-0 w-3/5 h-[45%] md:h-[48%] object-cover max-w-full z-0"
              alt="K2 development"
            />
            <img
              src={innerRenderPaths[11]}
              // src={image4}
              loading="lazy"
              data-nuxt-img=""
              id="w-node-_7df739b9-b0f3-491f-7539-52dca451dd1e-0a6b3cff"
              className="opacity-90 rounded-3xl absolute top-1/2 transform -translate-y-1/2 right-0 w-3/5 h-[45%] object-cover max-w-full z-10"
              alt="K2 development"
            />
            <img
              src={innerRenderPaths[5]}
              // src={image6}
              loading="lazy"
              data-nuxt-img=""
              id="w-node-_7df739b9-b0f3-491f-7539-52dca451dd1e-0a6b3cff"
              className="opacity-100 rounded-3xl absolute bottom-0 left-0 w-3/5 h-[45%] md:h-[48%] object-cover max-w-full z-20"
              alt="K2 development"
            />
          </div>

          <div
            id="w-node-_2e4eb166-4b61-2f69-94fe-26acf7daebc2-0a6b3cff"
            className="relative col-span-full lg:col-start-8 lg:col-span-4"
          >
            <h2 className="text-4xl font-gilroy">
              ტექნიკური <br /> მახასიათებლები
            </h2>
            <div className="flex flex-col gap-[21px] mb-[21px] mt-[40px] ">
              <div className="project_details-list-item">
                <div className="text-[34px] font-extrabold leading-none mb-[8px] text-primary-orange">
                  1
                </div>
                <div>
                  <p className="text-xl font-light">
                    1 სართული - კომერციული და საოფისე სივრცე
                  </p>
                </div>
              </div>
              <div className="project_details-list-item">
                <div className="text-[34px] font-extrabold leading-none mb-[8px] text-primary-orange">
                  2
                </div>
                <div>
                  <p className="text-xl font-light">
                    საპარკინგე ზონა და ფიტნეს ცენტრი
                  </p>
                </div>
              </div>
              <div className="project_details-list-item">
                <div className="text-[34px] font-extrabold leading-none mb-[8px] text-primary-orange">
                  3
                </div>
                <div>
                  <p className="text-xl font-light">
                    4 - {Projects[1].totalFloors} სართული - საცხოვრებელი სივრცე
                  </p>
                  <p className="text-xl font-light">
                    {Projects[1].totalApartments} აპარტამენტი
                  </p>
                </div>
              </div>
            </div>
            <a
              href="/projects/greenhome/block"
              onClick={(event) => {
                delayNavigation(
                  dispatch,
                  navigate,
                  "/projects/nikea/block",
                  event
                );
              }}
              className="flex flex-col items-center justify-center relative whitespace-nowrap w-fit cursor-pointer text-lg font-extrabold tracking-[3.36px] leading-[1.2] uppercase"
            >
              იპოვე ბინა
            </a>
            <img
              src="https://biograpi.ge/_nuxt/Connection--friendship.844e596a.svg"
              width="93"
              height="55"
              alt=""
              className="absolute -bottom-20 left-auto mt-9 right-0 top-auto"
            />
          </div>
          <div
            id="w-node-_130716d3-f835-6ce5-9418-6d2ec2857e64-0a6b3cff"
            className="col-span-11 row-span-1 bg-[#1a1120] h-[2px] mt-28 opacity-30 w-full "
          ></div>
        </div>
      </div>
    </Section>
  );
};

export default SectionProjectDetails;
